import React, { Component } from 'react'
import Translation from '../../../Translation/cont/Translation'

class BackdropPickerDialog extends Component {
    constructor(props) {
        super(props)
        this.state = { pendingUrl: props.selectedUrl || null }
    }

    render() {
        const { backdrops, onSelect, onCancel } = this.props
        const { pendingUrl } = this.state

        return (
            <div className="dialog-overlay" onClick={onCancel}>
                <div className="dialog" onClick={e => e.stopPropagation()}>
                    <div className="dialog-header">
                        <span className="dialog-title text-small-regular"><Translation id="social_media_select_backdrop_title" /></span>
                    </div>
                    <div className="dialog-body dialog-body--padded">
                        {backdrops.length === 0 && (
                            <p className="dialog-empty"><Translation id="social_media_no_backdrops" /></p>
                        )}
                        <div className="backdrop-picker-grid">
                            {backdrops.map((backdrop, i) => {
                                const url        = typeof backdrop === 'string' ? backdrop : (backdrop.url || backdrop.src || '')
                                const isSelected = pendingUrl === url
                                return (
                                    <div key={i}
                                        className={`backdrop-picker-item${isSelected ? ' backdrop-picker-item--selected' : ''}`}
                                        onClick={() => this.setState({ pendingUrl: url })}>
                                        <img src={url} alt={`Backdrop ${i + 1}`} />
                                        {isSelected && <span className="backdrop-picker-check">✓</span>}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="dialog-footer">
                        <button className="dlg-btn-cancel" onClick={onCancel}><Translation id="cancel_button" /></button>
                        <button className="dlg-btn-ok" disabled={!pendingUrl}
                            onClick={() => pendingUrl && onSelect(pendingUrl)}>
                            <Translation id="apply_button" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default BackdropPickerDialog
